import {
  accept_enum,
  accept_enum_three,
  accept_enum_two,
  category_address_enum,
  passed_the_military_data,
  personal_status_data,
} from "./enum/enum-personnel";

export const initial_form_personal_record_test = {
  profile: null,
  is_publish: 0,
  title: "นาย", // i18n-ignore
  title_eng: "Mr",
  first_name: "ป้อบแคท", // i18n-ignore
  first_name_eng: "pop cat",
  last_name: "นนทการ", // i18n-ignore
  last_name_eng: "Nantakhan",
  buddhist_name: "ฉายาสมมติ", // i18n-ignore
  buddhist_name_eng: "Joh doe",
  place_of_birth: "wat son",
  province: "สงขลา", // i18n-ignore
  employee_no: "182739928",
  phone_number: "0-123-4234",
  email_personal: "excemple@gmail.com",
  email_organization: "excemple_manage@gmo.com",
  gender: "หญิง", // i18n-ignore
  passed_the_military: passed_the_military_data.EXEMPT,
  personal_status: personal_status_data.SINGLE,
  idcard: "1929329392919",
  date_issue: "2024-08-28",
  date_expiry: "2024-08-28",
  date_of_birth: "2024-08-28",
  race: "thai",
  nationality: "thai",
  religion: "พุทธ", // i18n-ignore
  disabled: "ไม่มี", // i18n-ignore
  disabled_detail: "",
  employee_work_salary:"300000",
  employee_work_level:"วศ.06", // i18n-ignore
  // number_of_siblings: 2,
  date_of_ordination: "2024-08-28",
  receipt_number: "0229392993",
  church: "เถรวาท", // i18n-ignore
  date_start_work: "2024-08-28",
  date_end_work: "2024-08-28",
  phone_work: "0-982773-29",
  idposition: 1, // รอ master // i18n-ignore
  start_date: "2024-08-28",
  status: "active",
  emergency_contacts_name: "โจโฉ", // i18n-ignore
  emergency_contacts_relationship: "พี่น้อง", // i18n-ignore
  emergency_contacts_mobile_first: "098-298-2888",
  emergency_contacts_mobile_second: "061-287-2888",
  emergency_contacts_mobile_address: "ซอยบางรักพัฒนา กทม.", // i18n-ignore
  additional_information: {
    is_publish: 0,
    language_proficiency: [
      {
        language_name: "ไทย", // i18n-ignore
        level_speaking: "ดีมาก", //enum // i18n-ignore
        level_writing: "แย่", //enum // i18n-ignore
        level_reading: "ดีมาก", //enum // i18n-ignore
        level_printing: "ดีมาก", //enum // i18n-ignore
        status: "active",
      },
    ],
    other_abilities: [
      {
        abilities_name: "กินน้ำ", // i18n-ignore
        level_abilities: "ดีมาก", //enum // i18n-ignore
        status: "active",
      },
    ],
    driving_skills: {
      can_drive_car: 0,
      have_license_car: 1,
      have_car: 1,
      can_drive_motorcycle: 0,
      have_license_motorcycle: 1,
      have_motorcycle: 0,
      experience: "ขับรถเหาะได้", // i18n-ignore
    },
    work_other_province: {
      work_other_provinces_regularly: accept_enum.YES, //enum
      work_other_provinces_temporarily: accept_enum.YES, //enum
    },
    work_abroad: {
      work_abroad_regularly: accept_enum.YES, //enum
      work_abroad_temporarily: accept_enum.YES, //enum
    },
    work_shifts: accept_enum.YES, //enum
    serious_injury: accept_enum_two.NEVER, // enum
    congenital_disease: {
      congenital_disease: accept_enum_three.NOT_HAVE, //enum
      congenital_disease_detail: "",
    },
    employee_in_company: {
      employee_in_company: accept_enum_two.NEVER, // enum
      employee_in_company_start: null,
      employee_in_company_end: null,
      employee_in_company_position: "",
      employee_in_company_department: "",
    },
    relatives_work_company: {
      relatives_work_company: accept_enum_three.NOT_HAVE, //enum
      relatives_work_company_name: "",
      relatives_work_company_department: "",
      relatives_work_company_relationship: "", //enum
    },
    criminal_penalty: {
      criminal_penalty: accept_enum_two.NEVER, //enum,
      criminal_penalty_detail: "",
    },
  },
  parent_info: {
    is_publish: 0,
    father_name: "สมทบ", // i18n-ignore
    father_nationality: "",
    father_status_alive: "มีชีวิต", // i18n-ignore
    father_occupation: "-",
    mother_nationality: "",
    mother_name: "มัม", // i18n-ignore
    mother_status_alive: "มีชีวิต", // i18n-ignore
    mother_occupation: "-",
    mother_income: "10000",
    status_parent: "อยู่ด้วยกัน", // i18n-ignore
    spouse_name: "ชื่อ-นามสกุล ภรรยา/สามี", // i18n-ignore
    spouse_last_name: "นามสกุลเดิมคู่สมรส", // i18n-ignore
    spouse_idcard: "19283823823",
    spouse_nationality: "สัญชาติคู่สมรส", // i18n-ignore
    spouse_birthday: "2024-08-01",
    spouse_occupation: "อาชีพคู่สมรส", // i18n-ignore
    spouse_work_place: "ทำงานที่บ้าน", // i18n-ignore
    child_qty: 2,
  },
  siblings: [
    {
      siblings_name: "ราหู", // i18n-ignore
      siblings_old: "30",
      siblings_occupation: "benz",
      siblings_workplace: "บางกอก", // i18n-ignore
      status: "active",
    },
  ],
  address_info: {
    // "address_name": "testupdate",
    // "address_name_second": "testupdate",
    id_address_type: 1,
    is_publish: 0,
    house_number: "120",
    moo: "-",
    soi: "ลัดาแลน", // i18n-ignore
    road: "มิตรภาพ", // i18n-ignore
    province: "เชียงใหม่", // i18n-ignore
    district: "-",
    district_sub: "-",
    postcode: "1000",
  },
  address_registration_house: {
    id_address_type: 5,
    is_publish: 1,
    address_name: "",
    address_name_second: "",
    house_number: "",
    moo: "หมู่", // i18n-ignore
    soi: "ซอย", // i18n-ignore
    road: "ถนน", // i18n-ignore
    province: "จังหวัด", // i18n-ignore
    district: "ขข", // i18n-ignore
    district_sub: "ขขข", // i18n-ignore
    postcode: "23238283",
    is_address_idcard: false,
    catagory_address: category_address_enum.PRIVATE_HOME,
  },
  current_address: {
    is_publish: 0,
    is_address_idcard: false,
    id_address_type: 2,
    house_number: "120",
    catagory_address: category_address_enum.PRIVATE_HOME,
    moo: "-",
    soi: "ลัดาแลน", // i18n-ignore
    road: "มิตรภาพ", // i18n-ignore
    province: "เชียงใหม่", // i18n-ignore
    district: "-",
    district_sub: "-",
    postcode: "1000",
  },
  temple_address: {
    id_address_type: 3,
    address_name: "watson",
    is_publish: 0,
    house_number: "120",
    moo: "-",
    soi: "ลัดาแลน", // i18n-ignore
    road: "มิตรภาพ", // i18n-ignore
    province: "เชียงใหม่", // i18n-ignore
    district: "-",
    district_sub: "-",
    postcode: "1000",
  },
  work_address: {
    id_address_type: 4,
    address_name: "test", //address_name
    address_name_second: "test2", //address_name_second
    is_publish: 0,
    house_number: "120",
    moo: "-",
    soi: "ลัดาแลน", // i18n-ignore
    road: "มิตรภาพ", // i18n-ignore
    province: "เชียงใหม่", // i18n-ignore
    district: "-",
    district_sub: "-",
    postcode: "1000",
  },
  student_history: {
    is_publish: 0,
    student_history_data: [
      {
        certificate: "ปริญญาตรี", // i18n-ignore
        faculty: "วิศวกรรมศาสตร์และเทคโนโลยี", // i18n-ignore
        major: "การสื่อสาร", // i18n-ignore
        minor: "ไม่มี", // i18n-ignore
        id_education_type: 1,
        date_start_study: "2024-08-08",
        date_end_study: "2024-08-28",
        status: "active",
      },
    ],
  },
  work_history: {
    // id_work:1,
    is_publish: 0,
    next_position: "",
    management_position: "",
    duration: "",
    work_history_data: [
      {
        company: "v2n developer",
        work_contact_status: "ได้", // i18n-ignore
        work_contact: "987654321",
        date_start_work: "2024-08-16",
        date_end_work: "2024-08-28",
        position_start: "ทดสอบบ", // i18n-ignore
        position_end: "ทดสอบบุดท้าย", // i18n-ignore
        salary_start: "20000",
        salary_end: "10000",
        income_other: "30000",
        reason_for_leaving: "-",
        is_publish: 1,
      },
    ],
  },
  training: {
    is_publish: 0,
    training_data: [],
  },
  brief_history: {
    is_publish: 0,
    background_data: {
      // text
      background_detail: "ทดสอบการทำงาน", // i18n-ignore
    },
    background_social_media_data: [
      {
        type: "facebook",
        background_social_media_link: "www.facebook.com",
      },
      {
        type: "ig",
        background_social_media_link: "www.instagram.com",
      },
      {
        type: "x",
        background_social_media_link: "www.x.com",
      },
      {
        type: "youtube",
        background_social_media_link: "www.youtube.com",
      },
    ],
  },
  article: {
    article_detail: "ทดสอบการทำงาน", // i18n-ignore
    is_publish: 1,
  },
};
export const initial_form_personal_record = {
  profile: null,
  is_publish: 0,
  title: "",
  title_eng: "",
  first_name: "",
  first_name_eng: "",
  last_name: "",
  last_name_eng: "",
  buddhist_name: "",
  buddhist_name_eng: "",
  place_of_birth: "",
  province: "",
  employee_no: "",
  phone_number: "",
  email_personal: "",
  email_organization: "",
  gender: "",
  passed_the_military: passed_the_military_data.EXEMPT,
  personal_status: personal_status_data.SINGLE,
  idcard: "",
  date_issue: "",
  date_expiry: "",
  date_of_birth: "",
  race: "",
  nationality: "",
  employee_work_salary:"",
  employee_work_level:"",
  religion: "",
  disabled: accept_enum_three.NOT_HAVE,
  disabled_detail: "",
  // number_of_siblings: 0,
  date_of_ordination: "",
  receipt_number: "",
  church: "",
  date_start_work: null,
  date_end_work: null,
  phone_work: "",
  idposition: 1, // รอ master // i18n-ignore
  start_date: null,
  status: "active",
  emergency_contacts_name: "",
  emergency_contacts_relationship: "",
  emergency_contacts_mobile_first: "",
  emergency_contacts_mobile_second: "",
  emergency_contacts_mobile_address: "",
  additional_information: {
    is_publish: 0,
    language_proficiency: [
      {
        language_name: "",
        level_speaking: "", //enum
        level_writing: "", //enum
        level_reading: "", //enum
        level_printing: "", //enum
        status: "active",
      },
    ],
    other_abilities: [
      {
        abilities_name: "",
        level_abilities: "", //enum
        status: "active",
      },
    ],
    driving_skills: {
      can_drive_car: 0,
      have_license_car: 0,
      have_car: 0,
      can_drive_motorcycle: 0,
      have_license_motorcycle: 0,
      have_motorcycle: 0,
      experience: "",
    },
    work_other_province: {
      work_other_provinces_regularly: accept_enum.YES, //enum
      work_other_provinces_temporarily: accept_enum.YES, //enum
    },
    work_abroad: {
      work_abroad_regularly: accept_enum.YES, //enum
      work_abroad_temporarily: accept_enum.YES, //enum
    },
    work_shifts: accept_enum.YES, //enum
    serious_injury: accept_enum_two.NEVER, // enum
    congenital_disease: {
      congenital_disease: accept_enum_three.NOT_HAVE, //enum
      congenital_disease_detail: "",
    },
    employee_in_company: {
      employee_in_company: accept_enum_two.NEVER, // enum
      employee_in_company_start: null,
      employee_in_company_end: null,
      employee_in_company_position: "",
      employee_in_company_department: "",
    },
    relatives_work_company: {
      relatives_work_company: accept_enum_three.NOT_HAVE, //enum
      relatives_work_company_name: "",
      relatives_work_company_department: "",
      relatives_work_company_relationship: "", //enum
    },
    criminal_penalty: {
      criminal_penalty: accept_enum_two.NEVER, //enum,
      criminal_penalty_detail: "",
    },
  },
  parent_info: {
    is_publish: 0,
    father_name: "",
    father_status_alive: null,
    father_occupation: "",
    father_nationality: "",
    mother_name: "",
    mother_status_alive: null,
    mother_occupation: "",
    mother_nationality: "",
    status_parent: "",
    spouse_name: "",
    spouse_last_name: "",
    spouse_idcard: "",
    spouse_nationality: "",
    spouse_birthday: null,
    spouse_occupation: "",
    spouse_work_place: "",
    child_qty: null,
  },
  siblings: [
    {
      siblings_name: "",
      siblings_old: "",
      siblings_occupation: "",
      siblings_workplace: "",
      status: "active",
    },
  ],
  address_info: {
    // "address_name": "testupdate",
    // "address_name_second": "testupdate",
    id_address_type: 1,
    is_publish: 0,
    house_number: "",
    moo: "",
    soi: "",
    road: "",
    province: "",
    district: "",
    district_sub: "",
    postcode: "",
  },
  address_registration_house: {
    id_address_type: 5,
    is_publish: 0,
    address_name: "",
    address_name_second: "",
    house_number: "",
    moo: "",
    soi: "",
    road: "",
    province: "",
    district: "",
    district_sub: "",
    postcode: "",
    is_address_idcard: false,
    catagory_address: category_address_enum.PRIVATE_HOME,
  },
  current_address: {
    is_publish: 0,
    is_address_idcard: false,
    id_address_type: 2,
    house_number: "",
    catagory_address: category_address_enum.PRIVATE_HOME,
    moo: "",
    soi: "",
    road: "",
    province: "",
    district: "",
    district_sub: "",
    postcode: "",
  },
  temple_address: {
    id_address_type: 3,
    address_name: "",
    is_publish: 0,
    house_number: "",
    moo: "",
    soi: "",
    road: "",
    province: "",
    district: "",
    district_sub: "",
    postcode: "",
  },
  work_address: {
    id_address_type: 4,
    address_name: "", //address_name
    address_name_second: "", //address_name_second
    is_publish: 0,
    house_number: "",
    moo: "",
    soi: "",
    road: "",
    province: "",
    district: "",
    district_sub: "",
    postcode: "",
  },
  student_history: {
    is_publish: 0,
    student_history_data: [],
  },
  work_history: {
    is_publish: 0,
    next_position: "",
    management_position: "",
    duration: "",
    work_history_data: [],
  },
  training: {
    is_publish: 0,
    training_data: [],
  },
  brief_history: {
    is_publish: 0,
    background_data: {
      // text
      background_detail: "",
    },
    background_social_media_data: [
      {
        type: "facebook",
        background_social_media_link: "",
      },
      {
        type: "ig",
        background_social_media_link: "",
      },
      {
        type: "x",
        background_social_media_link: "",
      },
      {
        type: "youtube",
        background_social_media_link: "",
      },
    ],
  },
  article: {
    article_detail: "",
    is_publish: 1,
  },
};
